import React, { FC, useState } from 'react';
import { Box } from '@src/atoms/Box';
import { RadioButtonOption } from './_Option/RadioButtonOption';
import { INestedRadioButtonComponents, IRadioButtonProps } from './models';
import { useMergedValue } from '@src/utils/useMergedValue';
import { onUnitClickCallback } from '@src/core/Unit';

export const RadioButton: FC<IRadioButtonProps> & INestedRadioButtonComponents = ({
  options,
  className,
  style,
  view,
  id,
  onChange,
  value: propsValue,
}) => {
  const [value, setValue] = useState<string>(options[0].value || '');
  const { mergedValue } = useMergedValue({
    value,
    propsValue,
  });

  const handleChange = (newValue: string) => {
    if (propsValue === undefined) {
      setValue(newValue);
    }

    onChange?.(newValue);
  };

  return (
    <Box
      column
      className={className}
      style={style}
      gap={16}
      alignItems="start"
      data-id={id}
      onClick={onUnitClickCallback(id)}
    >
      {options &&
        options.map((option) => {
          return (
            <RadioButtonOption
              key={option.value}
              label={option.label}
              value={option.value}
              checked={option.value === mergedValue}
              disabled={option.disabled}
              onChange={handleChange}
              view={view}
              radioGroupId={id}
            />
          );
        })}
    </Box>
  );
};

RadioButton.Item = RadioButtonOption;
